import i18next from 'i18next';
import { map } from 'lodash';

import { Math } from 'classes';
import {
  NotificationEvent,
  NotificationEventGroup,
  UserRole,
  UserStatus,
} from 'enums';
import { AgentInfo } from 'types';

const getRoleLabel = (role: UserRole) => {
  const { t } = i18next;
  const key = `role.${role}`;
  return i18next.exists(key) ? t(key as any) : key;
};

const getStatusLabel = (status: UserStatus) => {
  const { t } = i18next;
  const key = `features.user.status.${status}`;
  return i18next.exists(key) ? t(key as any) : key;
};

const getNotificationEventLabel = (event: NotificationEvent) => {
  const key = `components.settings.notifications.event_names.${event}`;
  return i18next.t(key, { defaultValue: event });
};

const getNotificationGroupLabel = (event: NotificationEventGroup) => {
  const key = `components.settings.notifications.event_group.${event}`;
  return i18next.t(key, { defaultValue: event });
};

const getAgentCommission = (agent: AgentInfo, isPayin: boolean) =>
  (isPayin
    ? agent.payinCompensationPercentage
    : agent.payoutCompensationPercentage) || 0;

const getAgentsCommission = (agents: AgentInfo[], isPayin: boolean): number =>
  new Math(0).plus(
    ...map(agents, (agent) => getAgentCommission(agent, isPayin)),
  ).value;

export const userUtils = {
  getRoleLabel,
  getStatusLabel,
  getNotificationEventLabel,
  getNotificationGroupLabel,
  getAgentCommission,
  getAgentsCommission,
};
